import Inputmask from 'inputmask';

//Mascara para celular
const seletorCampoCelular = document.getElementById('mascara-celular');
if (seletorCampoCelular) {
    const inputmaskCelular = new Inputmask('+99 (99) 99999-9999');
    inputmaskCelular.mask(seletorCampoCelular);
}

//Mascara de CEP
const seletorCampoCep = document.getElementById('mascara-cep');
if (seletorCampoCep) {
    const inputmaskCep = new Inputmask('99999-999');
    inputmaskCep.mask(seletorCampoCep);
}

//Mascara CPF/CNPJ
const seletorCampoCpfCnpj = document.getElementById('mascara-cpf-cnpj');
if (seletorCampoCpfCnpj) {
    const inputmaskCpfCnpj = new Inputmask(['999.999.999-99', '99.999.999/9999-99']);
    inputmaskCpfCnpj.mask(seletorCampoCpfCnpj);
}

//Mascara CNPJ
const seletorCampoCnpj = document.getElementById('mascara-cnpj');
if (seletorCampoCnpj) {
    const inputmaskCnpj = new Inputmask(['99.999.999/9999-99']);
    inputmaskCnpj.mask(seletorCampoCnpj);
}

//Mascara dinheiro
const seletorMascaraDinheiro = document.querySelectorAll('.mascara-dinheiro');
if (seletorMascaraDinheiro.length > 0) {
    const inputmaskDinheiro = new Inputmask('currency', {
        autoUnmask    : true,
        radixPoint    :',',
        groupSeparator: '.',
        allowMinus    : false,
        prefix        : 'R$ ',
        digits        : 2,
        digitsOptional: false,
        rightAlign    : false,
        unmaskAsNumber: true
    });

    inputmaskDinheiro.mask(seletorMascaraDinheiro);
}
